/**
 * sectionUtils — pure helpers over the section JSON list.
 *
 * Kept separate from DynamicPageRenderer so callers (and tests) can use them
 * without pulling in SectionRegistry and, through it, every section component.
 */

export function visibleSections(sections = []) {
  return [...sections]
    .filter(s => s.is_visible !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

/**
 * True when the last visible section is a full-page HTML/CSS iframe. Such a
 * section is `height: 100vh` and scrolls internally, so anything the parent
 * renders below it needs a second scrollbar. Callers use this to move the
 * footer inside the iframe instead.
 */
export function lastSectionOwnsScroll(sections = []) {
  const visible = visibleSections(sections);
  const last = visible[visible.length - 1];
  return !!last
    && last.section_type === 'html_css_workspace'
    && last.section_config?.render_mode === 'fullpage';
}
